import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const SearchPDFsField = ({ limitSelectOptions, disabled }) => {
  return (
    <Field name="search_pdfs" parse={({ value }) => value}>
      {({ input }) => (
        <Fragment>
          <label>Search text of PDF documents</label>
          <Select
            {...input}
            clearable={false}
            options={limitSelectOptions}
            className="form-select"
            disabled={disabled}
          />
        </Fragment>
      )}
    </Field>
  );
};

SearchPDFsField.propTypes = {
  limitSelectOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

SearchPDFsField.defaultProps = {
  disabled: false,
};

export default SearchPDFsField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/SearchPDFsField.jsx